interface Props {
  color?: string;
  scale?: number;
}

const Diagonal = ({
  color = 'black',
  scale = 1,
}: Props) => {
  return (
    <svg
      width="100%"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 500 ${34 * scale}`}
    >
      <g transform={`scale(1, ${scale})`}>
        <path
          fill={color}
          d="M0 34H500V-9.53674e-07L0  34Z"
          // fillOpacity="0.75"
        />
      </g>
    </svg>
  );
};

export default Diagonal;
